import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { dropdownStyles } from 'styles/dropdown';
import styles from './dropdown.style';

const IconComponent = (props) => (
  <ArrowDropDownIcon data-testid="ArrowDropDownIcon" {...props} />
);

const Dropdown = ({
  value = '',
  onChange,
  error,
  type,
  loading = false,
  disabled = false,
  options,
  name,
  multiple = false,
  ...rest
}) => {
  // For multiple mode, convert object array to primitive array for MUI Select
  const selectValue = multiple
    ? (Array.isArray(value) ? value : []).map((v) => v?.value ?? v)
    : value;

  const _handleOnChange = (e) => {
    if (onChange) {
      if (multiple) {
        const selected = e.target.value;
        const selectedOptions = selected.map(
          (val) => options.find((opt) => opt.value === val) || val
        );
        onChange(selectedOptions);
      } else {
        onChange(e.target.value);
      }
    }
  };

  const getIsSelected = (itemValue) => {
    if (
      itemValue === null ||
      itemValue === undefined ||
      value === null ||
      value === undefined
    )
      return false;

    if (multiple) {
      return selectValue.includes(itemValue);
    }

    return String(itemValue) === String(value);
  };

  return (
    <TextField
      select
      size="small"
      variant="outlined"
      sx={styles.textfield}
      defaultValue={rest.defaultValue || (multiple ? [] : '')}
      value={multiple ? selectValue : value}
      disabled={disabled || loading}
      onChange={_handleOnChange}
      error={!!error}
      SelectProps={{
        IconComponent,
        displayEmpty: true,
        multiple,
        ...(multiple && {
          renderValue: (selected) => {
            if (!selected?.length) return '';
            return selected.join(', ');
          },
        }),
        MenuProps: {
          disableScrollLock: true,
          PaperProps: {
            sx: {
              borderRadius: '8px',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              '& ul': {
                overflowX: 'auto',
                maxHeight: '300px',
                padding: '4px',
              },
            },
          },
        },
      }}
      data-testid={`input-${name || 'dropdown'}`}
      {...rest}
    >
      {options?.map((item) => {
        const isSelected = getIsSelected(item?.value);

        return (
          <MenuItem
            key={item.value}
            sx={{
              ...dropdownStyles.listItem,
              margin: '4px',
              ...(item.hidden && { display: 'none' }),
              ...(item.color && { color: item.color }),
            }}
            disabled={item.disabled}
            value={item.value}
          >
            {isSelected ? (
              <CheckCircleIcon sx={styles.radioIcon} />
            ) : (
              <RadioButtonUncheckedIcon sx={styles.radioUncheckedIcon} />
            )}
            {item.icon && item.icon}
            {item.text || item.label}{' '}
            {item.description && `- ${item.description}`}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default Dropdown;
